// Préfixe pour Enfance - peut être HOL_ENF, HOL_ENF3 ou HOL_ENF4
export const PREFIX_ENFANCE = 'HOL_ENF';
export const CODE_ENFANCE = PREFIX_ENFANCE;
export const CODE_REGIE_ENFANCE = 'ENF';
export const ENFANCE = 'Enfance 360';

export const CODE_ENFANCE_360 = '360_ENF';
export const CODE_REGIE_ENFANCE_360 = 'ENF';
export const ENFANCE_360 = 'Enfance 360';

export const CODE_MFO = 'HOL_PPEL';
export const CODE_REGIE_MFO = 'MFO';
export const MFO = 'Plateforme de paiement en ligne';

export const CODE_MFAC = 'HOL_MFAC';
export const CODE_REGIE_MFAC = 'MFAC';
export const MFAC = 'Multi-Facturation ';

export const CODE_LOOC = '360_LOOC';
export const CODE_REGIE_LOOC = 'LOOC';
export const LOOC = 'Location des lieux publics';

export const APPLICATIONS_REGIE_LISTE = {
  [CODE_ENFANCE]: ENFANCE,
  [`${CODE_ENFANCE}3`]: ENFANCE,
  [`${CODE_ENFANCE}4`]: ENFANCE,
  [CODE_REGIE_ENFANCE]: ENFANCE_360,
  [CODE_REGIE_MFO]: MFO,
  [CODE_REGIE_MFAC]: MFAC,
  [CODE_REGIE_LOOC]: LOOC,
};

export const CODE_JVS_TO_REGIE = {
  [CODE_ENFANCE]: CODE_REGIE_ENFANCE,
  [`${CODE_ENFANCE}3`]: CODE_REGIE_ENFANCE,
  [`${CODE_ENFANCE}4`]: CODE_REGIE_ENFANCE,
  [CODE_ENFANCE_360]: CODE_REGIE_ENFANCE_360,
  [CODE_MFO]: CODE_REGIE_MFO,
  [CODE_MFAC]: CODE_REGIE_MFAC,
  [CODE_LOOC]: CODE_REGIE_LOOC,
};

export const HANDLED_APPLICATIONS = [
  CODE_ENFANCE,
  CODE_ENFANCE_360,
  CODE_MFO,
  CODE_MFAC,
  CODE_LOOC,
];

// Plusieurs codes JVS Enfance pointent vers le même code régie ('ENF').
// Ordre de priorité décroissante pour le dédoublonnage : on conserve le code le plus prioritaire.
export const ENFANCE_CODES_PRIORITY = [
  CODE_ENFANCE_360, // '360_ENF'
  `${PREFIX_ENFANCE}4`, // 'HOL_ENF4'
  `${PREFIX_ENFANCE}3`, // 'HOL_ENF3'
  PREFIX_ENFANCE, // 'HOL_ENF'
];
